var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.32 18.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f15c22;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_23",
    "data-name": "Layer 23"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 9.16,
    cy: 9.16,
    r: 9.16
  }), /*#__PURE__*/React.createElement("g", {
    id: "_37yeJ3",
    "data-name": "37yeJ3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.94,2.83h2.44a.49.49,0,0,1,.49.51h0c-.15,2.88-.31,5.76-.45,8.63,0,.31-.1.43-.43.42-.52,0-1,0-1.59,0a.49.49,0,0,1-.49-.47L7.45,3.35A.49.49,0,0,1,7.94,2.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.7,
    y: 13.02,
    width: 2.92,
    height: 2.47,
    rx: 0.43
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.7d21240fd49b741a44c15da52ae1d68d.svg";
export { ForwardRef as ReactComponent };